/* Mel's Flowers PDP recipe block: panel toggling.

   The block server-renders one panel per variant (mel-recipe.liquid) and this
   listens on Dawn's own event bus. Dawn's variant change only swaps a fixed
   list of elements (price, sku, buy buttons, the picker itself), so the block
   swaps its own panels here. No fetching: every panel is already in the DOM.

   Deliberately no pre-select. Bunches and Stems anchors on Classic because
   Ashraf set that rung as its merchandising anchor. Mel's has no such decision,
   and moving a customer's size for them without one would be inventing policy
   in a script. */
(function () {
  function apply(variantId) {
    document.querySelectorAll('[data-mel-recipe]').forEach(function (root) {
      var shown = false;
      root.querySelectorAll('[data-mel-variant]').forEach(function (panel) {
        var on = panel.getAttribute('data-mel-variant') === String(variantId);
        panel.toggleAttribute('hidden', !on);
        if (on) shown = true;
      });
      /* An unavailable combination publishes no variant; keep the first panel
         rather than collapsing the block to nothing. */
      if (!shown) {
        var first = root.querySelector('[data-mel-variant]');
        if (first) first.removeAttribute('hidden');
      }
    });
  }

  /* Classic is Mel's anchor rung, the same name it carries on Bunches and
     Stems: second on the four tier ladder, first on the three tier one, so it
     is present on both. When a visitor lands with no ?variant in the URL it is
     selected through Dawn's own change handling, so price, buy button, URL and
     the recipe panels all move together. */
  function selectAnchor() {
    document.querySelectorAll('.product-form__input--pill').forEach(function (fieldset) {
      if (!fieldset.querySelector('.mel-opt')) return;
      var anchor = fieldset.querySelector('input[value="Classic"]');
      if (!anchor || anchor.checked || anchor.classList.contains('disabled')) return;
      /* Click the LABEL rather than setting .checked and firing a synthetic
         change. A real gesture is what Dawn's variant-selects listens for; the
         synthetic route moves the radio while price and cart stay behind. */
      var label = anchor.id ? document.querySelector('label[for="' + anchor.id + '"]') : null;
      if (label) { label.click(); } else { anchor.click(); }
    });
  }

  /* variant-selects is a module script, so it defines itself AFTER
     DOMContentLoaded. Firing before it upgrades moves the radio and nothing
     else. If it never upgrades the radio is left alone, because a selector that
     disagrees with the cart is worse than no pre-selection at all. */
  function preselectAnchor() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('variant-selects').then(function () {
      setTimeout(selectAnchor, 0);
    });
  }

  function init() {
    /* The bus may not exist yet, but that must not skip the pre-select too. */
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.variant) apply(event.data.variant.id);
      });
    }
    preselectAnchor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
